import React, {useEffect} from 'react'
import './SkillRoute.css'
import ComputerIcon from '@material-ui/icons/Computer'
import Aos from 'aos'
// import mfrid from "./images/mfrid.PNG";
// import calculator from './images/calculator.png'
// import portfolio from './images/portfolio-two.png'
// import amazonClone from "./images/amazonClone.png";
import Project from './Project.js'

import LaptopWindowsRoundedIcon from '@material-ui/icons/LaptopWindowsRounded'



function SkillRoute() {
    useEffect(() => {
        Aos.init({
            duration:1000
        })
    }, [])
    return (
      <div className="SkillRoute">
        <div className="container">
          <div className="skills" style={{ color: "white" }}>
            <div className="skillsRoute__header" data-aos="fade-right">
              <ComputerIcon
                style={{ width: "50px", height: "50px", marginTop: "10px" }}
              />
              <h1>My Skills</h1>
            </div>
            <div className="skills__container">
              <ul>
                <div data-aos="fade-right">
                  <li className="html">HTML</li>
                  <li className="css">CSS</li>
                  <li className="js">JS</li>
                  <li className="python">PYTHON</li>
                  <li className="react">REACT</li>
                  <li className="js">jQuery</li>
                </div>
                <div data-aos="fade-left">
                  <li className="bootstrap">BOOTSTRAP</li>
                  <li className="material">MATERIAL UI</li>
                  <li className="git">GIT HUB</li>
                  <li className="vs">VS CODE</li>
                  <li className="firebase">FIREBASE</li>
                </div>
              </ul>
            </div>
          </div>

          <div className="project">
            <div className="skillsRoute__header">
              <LaptopWindowsRoundedIcon
                style={{ width: "50px", height: "50px", marginTop: "10px" }}
              />
              <h1>My Works</h1>
            </div>
            <p className="projectSoFar"> These are all my projects that i have worked on so far.</p>
            {/* <div className="project__wrapper">
              <a
                href="https://mfird-staging.netlify.app/#"
                data-aos="fade-right"
              >
                <div className="project__holder">
                  <img src={mfrid} alt="avatar" className="image" />
                  <div className="overlay">
                    <div className="text">
                      <h2 style={{ marginBottom: "10px" }}>MFIRD</h2>
                      <p>
                        An organisation to provide a common platform for
                        professionals across industries.
                      </p>
                      <h5 style={{ marginTop: "10px" }}>
                        Technology used: HTML, CSS, JS
                      </h5>
                    </div>
                  </div>
                </div>
              </a>
              <a href="https://simple-calci.netlify.app/" data-aos="fade-left">
                <div className="project__holder">
                  <img src={calculator} alt="avatar" className="image" />
                  <div className="overlay">
                    <div className="text">
                      <h2 style={{ marginBottom: "10px" }}>CALCULATOR</h2>
                      <p>
                        A simple calculator which perform arithmatic operations.
                      </p>
                      <h5 style={{ marginTop: "10px" }}>
                        Technology used: HTML, CSS, JQUERY
                      </h5>
                    </div>
                  </div>
                </div>
              </a>
              <a href="https://yahiyyakhan.netlify.app/" data-aos="fade-right">
                <div className="project__holder">
                  <img src={portfolio} alt="avatar" className="image" />
                  <div className="overlay">
                    <div className="text">
                      <h2 style={{ marginBottom: "10px" }}>PORTFOLIO</h2>
                      <p>
                        A static portfolio which does not perform any user
                        interaction. Builded for myself in the early stage of
                        learning.
                      </p>
                      <h5 style={{ marginTop: "10px" }}>
                        Technology used: HTML, CSS, JS
                      </h5>
                    </div>
                  </div>
                </div>
              </a>
              <a href="https://clone-5fa64.web.app/" data-aos="fade-left">
                <div className="project__holder">
                  <img src={amazonClone} alt="avatar" className="image" />
                  <div className="overlay">
                    <div className="text">
                      <h2 style={{ marginBottom: "10px" }}>AMAZON CLONE</h2>
                      <p>Amazon Clone build with ReactJs</p>
                      <h5 style={{ marginTop: "10px" }}>
                        Technology used: REACT.JS, MATERIAL UI
                      </h5>
                    </div>
                  </div>
                </div>
              </a>
            </div> */}
            <Project />
          </div>
        </div>
      </div>
    );
}

export default SkillRoute
